import { Map } from 'immutable'

/**
 * @param {ReduxState} state redux state
 */
// eslint-disable-next-line import/prefer-default-export
export function selectTestarossa (state) {
  return state.testarossa || Map()
}
